import { MotionStaggerList } from "../../wrapper/MotionsWrapper";
import React from "react";
import Card from "./Card";
import { useTranslation } from "react-i18next";

const HowDoesItWork = () => {
  const { t } = useTranslation();
  const cards = [
    {
      number: 1,
      title: t("howDoesItWorkCard1Title"),
      description: t("howDoesItWorkCard1Description"),
      iconClass: "bg-test-icon",
    },
    {
      number: 2,
      title: t("howDoesItWorkCard2Title"),
      description: t("howDoesItWorkCard2Description"),
      iconClass: "bg-calendar-icon",
    },
    {
      number: 3,
      title: t("howDoesItWorkCard3Title"),
      description: t("howDoesItWorkCar3Description"),
      iconClass: "bg-handshake-icon",
    },
  ];

  return (
    <div id="how-does-it-work" className="container mx-auto px-4 py-10 bg-secondary scroll-mt-[200px]">
      <h2 className="text-4xl font-roboto text-[#212529] text-center mb-10">
        {t("howDoesItWork")}
      </h2>
      <div className="flex flex-wrap gap-14 justify-center">
        <MotionStaggerList stagger={0.2} delay={0.1} duration={0.6} repeat={false}>
          {cards.map((card, index) => (
            <Card
              key={index}
              number={card.number}
              title={card.title}
              description={card.description}
              iconClass={card.iconClass}
            />
          ))}
        </MotionStaggerList>
      </div>
    </div>
  );
};

export default HowDoesItWork;